import React from "react";
import { useState, useEffect } from "react";

export default function BusinessLoanBenefits() {

  const [isMobile, setIsMobile] = useState(false);

  // Set mobile flag based on window width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640); // sm breakpoint in Tailwind
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const items = [
    {
      title: "Debt-Free, Stress-Free",
      iconSrc: "/assets/img/debt.png",
      alt: "Debt Icon",
      desc: "Consolidate high-interest loans & credit card bills.",
      iconWidth: 30,
      iconHeight: 30,
    },
    {
      title: "Weddings Without Worries",
      iconSrc: "/assets/img/wedding.png",
      alt: "Wedding Icon",
      desc: "Make your big day grand, without budget blues.",
      iconWidth: 30,
      iconHeight: 30,
    },
    {
      title: "Upgrade Your Skills",
      iconSrc: "/assets/img/skill.png",
      alt: "Skill Upgrade Icon",
      desc: "Invest in education, courses, or career growth.",
      iconWidth: 30,
      iconHeight: 30,
    },
    {
      title: "Home Makeover Goals",
      iconSrc: "/assets/img/home.png",
      alt: "Home Makeover Icon",
      desc: "Renovate, refurnish, and redesign your space.",
      iconWidth: 30,
      iconHeight: 30,
    },
    {
      title: "Pack Your Bags",
      iconSrc: "/assets/img/bag.png",
      alt: "Travel Icon",
      desc: "That dream vacation? It's just a loan away.",
      iconWidth: 30,
      iconHeight: 30,
    },
    {
      title: "Health Comes First",
      iconSrc: "/assets/img/health.png",
      alt: "Health Icon",
      desc: "Medical emergencies covered, instantly.",
      iconWidth: 30,
      iconHeight: 30,
    },
  ];


  return (
    <section className="relative p-4 sm:p-8 lg:p-12 max-w-7xl mx-auto  z-[0]">
      <div className="hidden sm:block absolute bottom-[-10%] left-[-15%] sm:left-[-18%] w-screen h-[50vh] dotted-bg z-[-1]"></div>

      <div className="  bg-[#FFFFFF] px-4  xs:py-6 py-12  rounded-3xl shadow-md w-full sm:hidden">
        <h2 className="text-4xl  sm:text-6xl xs:text-[28px] font-atkinson mb-2 text-black">
          Why Take a{" "} <br/>
          <span className=" relative px-2 italic  font-pp-hatton z-[0]">
            <img src="/assets/img/papertorn.png" loading="lazy" className="-z-10 absolute -top-2 left-0 h-[50px] w-full" />
            Persoanl Loan?
          </span>
          Because Life Won’t Wait!
        </h2>
        <p className="text-[#000000]  mb-4 sm:mb-6 mt-3 font-atkinson text-lg xs:text-md leading-[1.1] max-w-3xl">
         A personal loan isn’t just about covering expenses; it’s about creating opportunities for a better, more secure future. Here’s why a personal loan makes sense:
        </p>
      </div>



      <h2 className="text-4xl hidden sm:block sm:text-6xl xs:text-3xl font-atkinson mb-2 text-black">
        Why Take a{" "}  <br className=" md:hidden" />
        <span className=" relative px-2 italic  font-pp-hatton z-[0]">
            <img src="/assets/img/papertorn.png" loading="lazy" className="-z-10 absolute -top-2 left-0 h-[80px] w-full" />
            Persoanl Loan?
          </span>  <br className=" md:hidden" />
        Because Life Won’t Wait!
      </h2>
      <p className="text-[#000000] hidden sm:block  mb-4 sm:mb-6 mt-3 font-atkinson text-lg xs:text-md leading-[1.1] max-w-3xl">
        A business loan isn’t just about borrowing money; it’s about unlocking new possibilities for growth. Here’s why a business loan makes sense:
      </p>

      <div className=" hidden sm:grid grid-cols-1 mt-3 sm:mt-5  md:grid-cols-2 lg:grid-cols-3 gap-12">
        {items.map(({ title, iconSrc, alt, desc, iconWidth, iconHeight }, i) => (
          <div key={i} className="p-2 sm:p-0 flex flex-col items-start font-atkinson gap-1 sm:gap-4 ">
            <div className="flex justify-left items-center gap-3 w-full ">
              <img
                src={iconSrc}
                alt={alt}
                width={isMobile ? iconWidth + 2 : iconWidth}
                height={isMobile ? iconHeight + 2 : iconHeight}
                className={` mt-1 shrink-0`}
              />
              <h3 className=" block sm:hidden text-2xl xs:text-xl max-w-[70%] sm:max-w-[50%] xs:max-w-[65%] leading-[1] xs:leading-5 text-black">{title}</h3>
            </div>
            <div>
              <h3 className=" hidden sm:block text-lg text-black">{title}</h3>
              <p className="text-md text-gray-600 mt-1 w-full sm:max-w-[70%] sm:text-sm  xs:text-[15px] leading-[1.1]">{desc}</p>
            </div>
          </div>
        ))}
      </div>

     
     {/* for mobile only */}


      <div className="  sm:hidden flex flex-col gap-1 ">
        {items.map(({ title, iconSrc, alt, desc, iconWidth, iconHeight }, i) => (
          <div key={i} className="p-4 rounded-3xl mt-2 bg-gradient-to-b  shadow-sm from-[#f7f1eb]/10 min-h-[150px] via-[#fffbf7] to-white  flex flex-col items-start font-atkinson gap-1 ">
            <div className="flex justify-left items-center gap-3 w-full ">
              <img
                src={iconSrc}
                alt={alt}
                width={isMobile ? iconWidth + 2 : iconWidth}
                height={isMobile ? iconHeight + 2 : iconHeight}
                className="mt-1 shrink-0"
              />
              <h3 className=" block sm:hidden text-2xl xs:text-xl max-w-[70%] sm:max-w-[50%] xs:max-w-[65%] leading-[1] xs:leading-5 text-black">{title}</h3>
            </div>
            <div>
              <h3 className=" hidden sm:block text-lg text-black">{title}</h3>
              <p className="text-md text-gray-600 mt-1 w-full sm:max-w-[70%] sm:text-sm  xs:text-[15px] leading-[1.1]">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
